module.exports = __webpack_public_path__ + "img/sts-60x60.94ab3794.png";